import React, { Component } from 'react';
import './css/Actividad.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Solicitud_actividad } from './expand/Solicitud_actividad';
import { Nueva_actividad } from './modal/Nueva_actividad';
import { Resumen_Observaciones } from './tablas/Resumen_Observaciones';
import { Tabla_Actividades } from './tablas/Tabla_Actividades';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row, Container } from 'react-bootstrap';
import crear from './../img/svg/Nueva.svg';

function color_head() {
    return {
        backgroundColor: '#25223f',
        color: 'white',
        width: '15%', fontSize: 11,
    };
}
 
function color_head_desc(tipo) {
    if (tipo == 'a') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '50%'
        };
    } else if (tipo == 'd') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        }
    } else if (tipo == 'id') {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '15%'
        };
    } else {
        return {
            backgroundColor: '#25223f',
            color: 'white', fontSize: 11,
            width: '30%'
        };
    }
}
//Funcion para colocar color a las celdasde la tabla
function color(rowIndex) {
    if (rowIndex % 2 === 0) {
        return {
            backgroundColor: 'white'
        };
    }
    return {
        backgroundColor: '#E7E7E7'
    };
}

const API_URL = process.env.REACT_APP_API_URL;

export class Investigacion extends Component {
    static displayName = Investigacion.name;

    handleBtnClick = () => {
        if (!this.state.expanded.includes(0)) {
            this.setState(() => ({
                expanded: [...this.state.expanded, 0]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== 0)
            }));

        }
    }

    handleOnExpand = (row, isExpand, rowIndex, e) => {
        if (isExpand) {
            this.setState(() => ({
                expanded: [...this.state.expanded, row.id]
            }));
        } else {
            this.setState(() => ({
                expanded: this.state.expanded.filter(x => x !== row.id)
            }));
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            actividades: [], solicitudes: [], busqueda: "", actividad: {
                idactividad: 0, actividad: "", tipoactividad: 0, descripcion: "", idtipoactividad: "", numhoras: 0,
                anio: "", termino1: "", termino2: "", termino3: "", periodicidad: "", totalhoras: 0, estadocheck: "", escarga: ""
            },
            actividad_elegida: [
                { idactividad: 0, validada: "", estado_actividad: "" }
            ], loading: false, loading2: false, loading3: false, expanded: [], total: 0,
            anio: props.anio, idpersona: props.idprof, actividades_combo: []
            , periodo: "", newactividad: "", observacion: "",
            nuevoregistro: [], selectact: "", selectidact: "", abierto: false, fila: [], valida_next: true, solicitudes_act:[]
        };
         
        this.isValidated_all = this.isValidated_all.bind(this);
        this.setfila = this.setfila.bind(this);
        this.updatestate = this.updatestate.bind(this);

        this.setconteo_final = this.setconteo_final.bind(this);
    }

    setconteo_final(tam) {
        //console.log('setconteo final en docencia de grado')
        //console.log(tam)
        this.props.setconteo_final(tam, 'I')
    }

    componentDidMount() {
        let solicitudes = this.props.getSolicitudes('')
        if (solicitudes) {
            this.setState({
                solicitudes_act: solicitudes
            })
        }

        if (this.state.idpersona > 0) {
            this.populateActividadesData(this.state.idpersona, this.state.anio);
            this.populateActividadesCombo(this.state.idpersona, this.state.anio);
        }
    }

    updatestate(rowIndex, idactividad, descripcion, totalhoras, anio, terminos, tipoactividad, observacion, pao1, pao2, pae, accion, idUnico) {
        var solicitudes = this.state.solicitudes
       
        if (solicitudes.length == 0) {
            solicitudes = []
        } else {
            solicitudes = this.state.solicitudes.filter(x => x.idactividad != idactividad)
        }

        solicitudes.push({
            idactividad: idactividad, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: terminos, tipoactividad: tipoactividad, observacion: observacion, pao1: pao1, pao2: pao2, pae: pae, accion: accion, idUnico: idUnico
        })
        this.setState({
            solicitudes: solicitudes
        });

        //this.isValidated_all(this.states.fila.length)
        this.props.update({ ambito: 'A|I', idactividad: idactividad, descripcion: descripcion, totalhoras: totalhoras, anio: anio, termino: terminos, tipoactividad: tipoactividad, observacion: observacion, pao1: pao1, pao2: pao2, pae: pae, accion: accion, idUnico: idUnico});

    }

    formatter = (valor) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: '2', minimumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    dateFormatter = (strFecha) => {
        var options = { year: 'numeric', month: '2-digit', day: 'numeric' };
        var dtFecha = new Date(strFecha);
        return dtFecha.toLocaleDateString("es-EC", options);
    }
     
    isValidated_all(tam) {
        let btncheckprevius = document.getElementsByClassName('btn-previous btn btn-secondary')[0];
        //if (btncheckprevius != undefined) {
        //    btncheckprevius.hidden = true;
        //}
        let btnchecknext = document.getElementsByClassName('btn-next btn btn-secondary')[0];

       // btnchecknext.disabled = true;
        //console.log('MATERIAS--->ES IGUAL: ' + tam + ' === ' + this.state.actividades.length)
        if (tam >= this.state.actividades.length) {
            //console.log('--->desbloquea siguiente ambito')
           // btnchecknext.disabled = false;
            this.setState({
                valida_next: true
            })
            //console.log('verifica vliidanext:' + this.state.valida_next)
           // btnchecknext.addEventListener('click', (e) => btnchecknext.disabled = true);

        }
    }
     
    toggle = () => {
        this.setState({ abierto: !this.state.abierto });
    }

    renderTotal() {
        const totalactividades = this.props.cargaAct ? this.props.cargaAct.map(horastot2 => horastot2.totalHoras).reduce((acc2, item2) => (Number(acc2) + Number(item2)), 0) : 0;
        const talambito = this.formatter(totalactividades);
        return (
            <div className="inline-grid  grid-cols-1 bg-total3">
                <div className="px-1 ">Total de Ámbito de Investigación: {talambito} horas</div>
            </div>
        )
    }

    setfila(tam) {
        this.setState({
            fila: tam
        })
        this.isValidated_all(tam)
    }
    render() {
         
        let btncheckprevius = document.getElementsByClassName('btn-previous btn btn-secondary')[0];
        if (btncheckprevius != undefined) {
            btncheckprevius.hidden = true;
        }

        if (this.state.valida_next) {
            let btnchecknext = document.getElementsByClassName('btn-next btn btn-secondary')[0];
            //if (btnchecknext != undefined) {
            //    btnchecknext.disabled = false;
            //    btnchecknext.addEventListener('click', (e) => btnchecknext.disabled = true);
            //}
        }

         
        let total = this.renderTotal()

        return (
            <div>
                <Resumen_Observaciones solicitudes={this.state.solicitudes_act} anio={this.props.anio} tipoactividad='I' /> {/*updatestate={this.updatestate} />*/}
                <Nueva_actividad actividades_combo={this.state.actividades_combo} anio={this.props.anio} abierto={this.state.abierto} toggle={this.toggle} tipoactividad='A|I' updatestate={this.updatestate} terminoPeriodo={this.props.terminoPeriodo} />
                <Tabla_Actividades actividades={this.state.actividades} anio={this.props.anio} fila_mat={this.state.fila_mat} materias={this.state.materias}
                    valida_next={this.state.valida_next} tipoactividad='I' updatestate={this.updatestate} fila={this.state.fila} setfila={this.setfila} setconteo_final={this.setconteo_final} setSolicitudes={this.props.setSolicitudes}
                    toggle={this.toggle} terminoPeriodo={this.props.terminoPeriodo}
                />
                {total}
            </div>
        );
    }

    async populateActividadesData(idpersona, anio) {

        const respuesta = this.props.cargaAct;
        const data = respuesta;
        var selected = [];
        var actividades = [];
        if (data) {
            data.map(act => { selected.push({ idactividad: act.idActividad, validada: "", estado_actividad: "" }) })
            //data.map(act => { actividades.push({ ambito: 'AR', idactividad: act.idactividad, totalhoras: act.totalhoras, anio: act.anio, termino: act.termino1 + '|' + act.termino2 + '|' + act.termino3 }) })
            data.map(act => { actividades.push({ ambito: 'A|I', idactividad: act.idActividad }) })
            var actividades2 = [];
            data.map(act => { actividades2.push({ tipo: 'A|I', idactividad: act.idActividad, anio: anio, descripcion: act.descripcion, periodo: act.termino1 + '|' + act.termino2 + '|' + act.termino3, accion: '', observacion: '', totalhoras: act.totalHoras, validado: 1, idUnico: act.idUnico }) })
            this.props.updateCarga(actividades, actividades2, 'A|I');
        }
        this.setState({ actividad_elegida: selected, actividades: data, loading: false });


    }

    async populateActividadesCombo(idpersona, anio) {
        const response = await fetch(API_URL + 'TblActividades/' + anio + '/I/token');
        const respuesta = await response.json();
        const data = respuesta;
        this.setState({ actividades_combo: data, loading: false });
    }

}
